import React from 'react'

import css from './style.css'
export default () => (
    <hr className={css.divider} />
)


// WEBPACK FOOTER //
// ./src/App/pages/CreateGym/Divider/index.js